export default __webpack_public_path__ + "312af5ea8f040856ea11fda1da8be688.png";